import '../../blocks/installer-form/installer-form.scss';
import HubAuthPopup from '../../blocks/hub-auth-popup/hub-auth-popup';
import './hub-settings.scss';
import '../../blocks/ring-breadcrumbs/ring-breadcrumbs.scss';
import ExternalValidator from '../../blocks/external-validator/external-validator';
import PickFileButton from '../../blocks/pick-file-button/pick-file-button';
import WizardInfo from '../../blocks/wizard-info/wizard-info';
import HubLogin from './hub-settings__login';
import UrlHelper from '../../blocks/url-helper/url-helper';
import SslCertificate from '../../blocks/ssl-certificate/ssl-certificate';

import HubSettingsController from './hub-settings__controller';

export default angular.module('installer.hub-settings', [
  HubAuthPopup.name,
  WizardInfo.name,
  ExternalValidator.name,
  HubLogin.name,
  UrlHelper.name,
  SslCertificate.name,
  PickFileButton.name
]).
  controller('HubSettingsController', HubSettingsController).
  config($routeProvider => {
    $routeProvider.
      when('/install/hub', {
        template: require('./hub-settings.html'),
        controller: 'HubSettingsController as ctrl',
        reloadOnSearch: false
      }).
      when('/install/hub/verify', {
        template: '',
        controller: 'HubAuthController as ctrl',
        reloadOnSearch: false
      });
  });



// WEBPACK FOOTER //
// ./src/pages/hub-settings/hub-settings.js